import * as React from 'react'
// store must be imported before all 'modules'
import { store } from './store'

import { ContextProvider } from './core'
import reducers from './reducers'
import HomeRoll from './modules/HomeRoll'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Page403, Page404, Page500 } from './modules/Errors'

export default class App extends React.Component {
  render() {
    return (
      <ContextProvider store={store} reducers={reducers}>
        <BrowserRouter>
          <Switch>
            <Route path="/errors/403" component={Page403}/>
            <Route path="/errors/404" component={Page404}/>
            <Route path="/errors/500" component={Page500}/>
            <Route exact={true} path="/csgo" render={() => (window.location.href = 'https://csgoempire.com/r/Davion')}/>
            <Route path={'/'} component={HomeRoll}/>
          </Switch>
        </BrowserRouter>
      </ContextProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx